/**
 * @file
 * The developement mixins for vue components.
 */
export default {
  methods: {
    log: console.log
  }
};
